(function() {
    window.c24Lp = window.c24Lp || {};

    window.c24Lp.log = function(sType, sText, mVars, bConsoleOnly) {

        if (typeof c24LpIsExported !== 'undefined' && !window.c24LpIsExported) {

            if (sType !== 'debug') {
                console.log(sType.toUpperCase() + ': ' + sText);
            } else {
                console.log(sText);
            }

            if (mVars) {
                console.log(mVars);
                console.log('---------');
            }
        }

        if (bConsoleOnly) {
            return;
        }

        const oError = new Error();
        const oParameters = {
            type: sType,
            text: sText,
        };

        if (oError.stack !== undefined) {
            const aLines = oError.stack.split('\n');
            aLines.splice(0, 1);
            oParameters.trace = aLines.join('\n');
        }

        if (mVars !== undefined) {
            oParameters.vars = mVars;
        }

        const oXhr = new XMLHttpRequest();
        oXhr.open('POST', window.c24LpRoot + 'api/?k=24&a=log', true);
        oXhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        oXhr.send('json_data=' + JSON.stringify(oParameters));
    };

    window.c24Lp.logInfo = function(sText, mVars) {
        window.c24Lp.log('info', sText, mVars);
    };

    window.c24Lp.logWarning = function(sText, mVars) {
        window.c24Lp.log('warning', sText, mVars);
    };

    window.c24Lp.logError = function(sText, mVars) {
        window.c24Lp.log('error', sText, mVars);
    };

    window.c24Lp.logDebug = function(sText, mVars) {
        window.c24Lp.log('debug', sText, mVars, true);
    };
})();
